import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { setDataExportTypeKey, clearPreviousQuote, resetAllFormFields } from '../../../../../redux/actions';
import componentBase from '../../../../../../../src/lib/component-base';
import IconHeader from '../../../../../../../shared/components/IconHeader/IconHeader';
import FSFlatButton from '../../../../../../../src/components/lib/FSFlatButton';

@componentBase('Type')
export default class Type extends Component {
  static propTypes = {
    icon: PropTypes.string,
    type: PropTypes.object,
    dispatch: PropTypes.func,
    push: PropTypes.func,
  };

  handleSubmit = () => {
    const { dispatch, push, type } = this.props;
    dispatch(setDataExportTypeKey(type.key));
    dispatch(resetAllFormFields());
    dispatch(clearPreviousQuote());
    push(`/data-exports/search/${type.searchTerm}`);
  };

  render = () => (
    <div className='col-xs-12 col-sm-6 col-md-3 type'>
      <div className='typeContainer'>
        <div className='typeContent'>
          <IconHeader icon={this.props.icon} title={this.props.type.name} />
          {this.props.type.description}
        </div>
      </div>
      <div className='startBtn'>
        <FSFlatButton
          label='START DATA EXPORT'
          onClick={this.handleSubmit}
          style={FSFlatButton.style({ height: '35px', width: '100%', borderRadius: '0px' })}
        />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./modules/DataExports/components/NewDataExports/children/Category/children/Type.js